var _excluded = ["children", "onSigninCallback", "skipSigninCallback", "onRemoveUser", "onSignoutRedirect", "onSignoutPopup", "implementation", "userManager"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/AuthContext.ts
import React from "react";
var AuthContext = /*#__PURE__*/React.createContext(void 0);
AuthContext.displayName = "AuthContext";

// src/AuthProvider.tsx
import React2, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { UserManager } from "oidc-client-ts";

// src/AuthState.ts
var initialAuthState = {
  isLoading: true,
  isAuthenticated: false
};

// src/reducer.ts
var reducer = function reducer(state, action) {
  switch (action.type) {
    case "INITIALISED":
    case "USER_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.user,
        isLoading: false,
        isAuthenticated: action.user ? !action.user.expired : false,
        error: void 0
      });
    case "USER_UNLOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        user: void 0,
        isAuthenticated: false
      });
    case "NAVIGATOR_INIT":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true,
        activeNavigator: action.method
      });
    case "NAVIGATOR_CLOSE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        activeNavigator: void 0
      });
    case "ERROR":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        error: action.error
      });
    default:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        error: new Error("unknown type ".concat(action["type"]))
      });
  }
};

// src/utils.ts
var hasAuthParams = function hasAuthParams() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  var searchParams = new URLSearchParams(location.search);
  if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) {
    return true;
  }
  searchParams = new URLSearchParams(location.hash.replace("#", "?"));
  if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) {
    return true;
  }
  return false;
};
var normalizeErrorFn = function normalizeErrorFn(fallbackMessage) {
  return function (error) {
    if (error instanceof Error) {
      return error;
    }
    return new Error(fallbackMessage);
  };
};
var loginError = normalizeErrorFn("Login failed");

// src/AuthProvider.tsx
var userManagerContextKeys = ["clearStaleState", "querySessionStatus", "revokeTokens", "startSilentRenew", "stopSilentRenew"];
var navigatorKeys = ["signinPopup", "signinSilent", "signinRedirect", "signinResourceOwnerCredentials", "signoutPopup", "signoutRedirect", "signoutSilent"];
var unsupportedEnvironment = function unsupportedEnvironment(fnName) {
  return function () {
    throw new Error("UserManager#".concat(fnName, " was called from an unsupported context. If this is a server-rendered page, defer this call with useEffect() or pass a custom UserManager implementation."));
  };
};
var defaultUserManagerImpl = typeof window === "undefined" ? null : UserManager;
var AuthProvider = function AuthProvider(props) {
  var children = props.children,
    onSigninCallback = props.onSigninCallback,
    skipSigninCallback = props.skipSigninCallback,
    onRemoveUser = props.onRemoveUser,
    onSignoutRedirect = props.onSignoutRedirect,
    onSignoutPopup = props.onSignoutPopup,
    _props$implementation = props.implementation,
    UserManagerImpl = _props$implementation === void 0 ? defaultUserManagerImpl : _props$implementation,
    userManagerProp = props.userManager,
    userManagerSettings = _objectWithoutProperties(props, _excluded);
  var _useState = useState(function () {
      return userManagerProp != null ? userManagerProp : UserManagerImpl ? new UserManagerImpl(userManagerSettings) : {
        settings: userManagerSettings
      };
    }),
    _useState2 = _slicedToArray(_useState, 1),
    userManager = _useState2[0];
  var _useReducer = useReducer(reducer, initialAuthState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var userManagerContext = useMemo(function () {
    return Object.assign({
      settings: userManager.settings,
      events: userManager.events
    }, Object.fromEntries(userManagerContextKeys.map(function (key) {
      var _a, _b;
      return [key, (_b = (_a = userManager[key]) == null ? void 0 : _a.bind(userManager)) != null ? _b : unsupportedEnvironment(key)];
    })), Object.fromEntries(navigatorKeys.map(function (key) {
      return [key, userManager[key] ? ( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: "NAVIGATOR_INIT",
                  method: key
                });
                _context.prev = 1;
                _context.next = 4;
                return userManager[key](args);
              case 4:
                return _context.abrupt("return", _context.sent);
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: "ERROR",
                  error: _context.t0
                });
                return _context.abrupt("return", null);
              case 11:
                _context.prev = 11;
                dispatch({
                  type: "NAVIGATOR_CLOSE"
                });
                return _context.finish(11);
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 7, 11, 14]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()) : unsupportedEnvironment(key)];
    })));
  }, [userManager]);
  var didInitialize = useRef(false);
  useEffect(function () {
    if (!userManager || didInitialize.current) {
      return;
    }
    didInitialize.current = true;
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var user;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            user = null;
            _context2.prev = 1;
            if (!(hasAuthParams() && !skipSigninCallback)) {
              _context2.next = 10;
              break;
            }
            _context2.next = 5;
            return userManager.signinCallback();
          case 5:
            user = _context2.sent;
            _context2.t0 = onSigninCallback;
            if (!_context2.t0) {
              _context2.next = 10;
              break;
            }
            _context2.next = 10;
            return onSigninCallback(user);
          case 10:
            if (user) {
              _context2.next = 16;
              break;
            }
            _context2.next = 13;
            return userManager.getUser();
          case 13:
            _context2.t1 = _context2.sent;
            _context2.next = 17;
            break;
          case 16:
            _context2.t1 = user;
          case 17:
            user = _context2.t1;
            dispatch({
              type: "INITIALISED",
              user: user
            });
            _context2.next = 24;
            break;
          case 21:
            _context2.prev = 21;
            _context2.t2 = _context2["catch"](1);
            dispatch({
              type: "ERROR",
              error: loginError(_context2.t2)
            });
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 21]]);
    }))();
  }, [userManager, skipSigninCallback, onSigninCallback]);
  useEffect(function () {
    if (!userManager) return void 0;
    var handleUserLoaded = function handleUserLoaded(user) {
      dispatch({
        type: "USER_LOADED",
        user: user
      });
    };
    userManager.events.addUserLoaded(handleUserLoaded);
    var handleUserUnloaded = function handleUserUnloaded() {
      dispatch({
        type: "USER_UNLOADED"
      });
    };
    userManager.events.addUserUnloaded(handleUserUnloaded);
    var handleSilentRenewError = function handleSilentRenewError(error) {
      dispatch({
        type: "ERROR",
        error: error
      });
    };
    userManager.events.addSilentRenewError(handleSilentRenewError);
    return function () {
      userManager.events.removeUserLoaded(handleUserLoaded);
      userManager.events.removeUserUnloaded(handleUserUnloaded);
      userManager.events.removeSilentRenewError(handleSilentRenewError);
    };
  }, [userManager]);
  var removeUser = useCallback(userManager ? function () {
    return userManager.removeUser().then(onRemoveUser);
  } : unsupportedEnvironment("removeUser"), [userManager, onRemoveUser]);
  var signoutRedirect = useCallback(function (args) {
    return userManagerContext.signoutRedirect(args).then(onSignoutRedirect);
  }, [userManagerContext.signoutRedirect, onSignoutRedirect]);
  var signoutPopup = useCallback(function (args) {
    return userManagerContext.signoutPopup(args).then(onSignoutPopup);
  }, [userManagerContext.signoutPopup, onSignoutPopup]);
  var signoutSilent = useCallback(function (args) {
    return userManagerContext.signoutSilent(args);
  }, [userManagerContext.signoutSilent]);
  return /* @__PURE__ */React2.createElement(AuthContext.Provider, {
    value: _objectSpread(_objectSpread(_objectSpread({}, state), userManagerContext), {}, {
      removeUser: removeUser,
      signoutRedirect: signoutRedirect,
      signoutPopup: signoutPopup,
      signoutSilent: signoutSilent
    })
  }, children);
};

// src/useAuth.ts
import React3 from "react";
var useAuth = function useAuth() {
  var context = React3.useContext(AuthContext);
  if (!context) {
    console.warn("AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.");
  }
  return context;
};

// src/withAuth.tsx
import React4 from "react";
function withAuth(Component) {
  var displayName = "withAuth(".concat(Component.displayName || Component.name, ")");
  var C = function C(props) {
    var auth = useAuth();
    return /* @__PURE__ */React4.createElement(Component, _objectSpread(_objectSpread({}, props), {}, {
      auth: auth
    }));
  };
  C.displayName = displayName;
  return C;
}
export { AuthContext, AuthProvider, hasAuthParams, useAuth, withAuth };